import React, {useContext} from 'react'
import  UserContext  from '../../context/Globales/UserContext';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {Paper }from '@material-ui/core';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
  

const useStyles = makeStyles((theme) => ({

  titulo: {
  backgroundColor: theme.palette.fondotitulos.main, 
  minWidth: 200,
  color: 'dark',
  },
  table: {
    backgroundColor: theme.palette.greyFondo.main, 
  }
}));


const DataTableRelacionCtaRut = () => {


      //const userContext = useContext(UserContext);
      const { DataOnp } = useContext(UserContext);

     {/* const columns = DataOnp.RelacionRUT[0] && Object.keys(DataOnp.RelacionRUT[0])*/}

      




      const classes = useStyles();
      
  



    return ( 
        <>


        
        
        <TableContainer component={Paper} elevation={3} >
          <div style={{textAlign: 'center',padding: '20px',  fontWeight: 'bold'}} className={classes.titulo}>Relacion Cuenta / Rut </div>
          
          <Table className={classes.table} stickyHeader aria-label="sticky table" size="small"  >            
            <TableHead >
              <TableRow >
              {/* DataOnp.RelacionRUT[0] && columns.map((heading) => <th> {heading}  </th> ) */}
         
              </TableRow>
            </TableHead>
            <TableBody>
              {/* si esta wea no mapea, tengo que agregarle el ? despues del RelacionRUT*/}
           {DataOnp.RelacionRUT?.map((item)=>(

            
            
              <TableRow hover > 
           
             <TableCell style={{textAlign: 'justify', paddingLeft: '140px', width: '50%'}} >
              {item.Concepto}              
             </TableCell> 
             <TableCell style={{textAlign: 'center'}} >
              :              
             </TableCell> 
             <TableCell style={{width: '880px', textAlign: 'left' ,  fontWeight: 'bold'}} >
              {item.Valor}             
             </TableCell> 
              </TableRow>
              ))}
              
              

            </TableBody>
            <TableFooter>
          <TableRow>

          </TableRow>
        </TableFooter>
          </Table>
        </TableContainer>
      

        </>
     );
}
 
export default DataTableRelacionCtaRut;